import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';
import {
  BACKEND_FIELD_GENERATOR_CONFIG,
  FIELD_ORDER_UI_SCHEMA_KEY,
  NUM_COLUMNS_KEY,
} from '../StepConfigEditorTypes';

export const RUN_TECAN_METHOD_V0_UI_SCHEMA: StepTypeConfigUISchemaV2<PipelineStepType.RUN_TECAN_METHOD, 0> = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['connectionId', 'methodName', 'outputDirectory', 'runtimeVariables'],
  [BACKEND_FIELD_GENERATOR_CONFIG]: {
    triggerFields: ['connectionId'],
    hasSavedShape: true,
    connectionField: 'connectionId',
    liveFields: ['methodName', 'runtimeVariables'],
    liveLoadingMessages: {onOpen: 'Loading methods from FluentControl…'},
  },
  connectionId: {
    displayName: 'Connection',
    infoText: 'The instrument connection to the Tecan FluentControl workstation.',
    configShapePath: ['connectionId'],
  },
  methodName: {
    displayName: 'Method',
    infoText: "The FluentControl method to run. Only methods marked 'Is visible in Touch Tools' are listed.",
    configShapePath: ['methodName'],
  },
  outputDirectory: {
    displayName: 'Output directory',
    infoText:
      'Optional. A directory on the FluentControl workstation to watch for output files. Files the run ' +
      'creates or changes here are attached to the step as outputs.',
    configShapePath: ['outputDirectory'],
  },
  runtimeVariables: {
    displayName: 'Variables',
    infoText:
      "Values for the method's variables. Each variable must have 'Query at Startup' set in the method; " +
      'names are case-sensitive.',
    configShapePath: ['runtimeVariables'],
    elementUISchema: {
      [FIELD_ORDER_UI_SCHEMA_KEY]: ['name', 'value'],
      [NUM_COLUMNS_KEY]: 2,
      name: {displayName: 'Variable', configShapePath: ['name']},
      value: {displayName: 'Value', configShapePath: ['value']},
    },
  },
};
